import { Grid, makeStyles } from '@material-ui/core'
import { FC } from 'react'

import ErrorIcon from '@material-ui/icons/Error'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import useTranslate from '../../../i18n/useTranslate'

interface StatusBarProps {
    id: string
    reason?: string
}
const StatusBar: FC<StatusBarProps> = ({ id, reason }) => {
    const classes = useStyles()
    const translate = useTranslate()

    const chooseClass = (status: string) => {
        switch (status) {
            case '2':
                return classes.approved
            case '3':
                return classes.reject

            default:
                break
        }
    }

    const chooseWord = (status: string) => {
        switch (status) {
            case '2':
                return (
                    <Grid container>
                        <CheckCircleIcon style={{ color: 'green', height: '100%', marginRight: '5px' }} />
                        <span style={{ color: 'green' }}>{translate.get('UM.APPROVE-RESEARCHER.APPROVED')}</span>
                    </Grid>
                )
            case '3':
                return (
                    <Grid container>
                        <ErrorIcon style={{ color: 'red', height: '100%', marginRight: '5px' }} />
                        <span style={{ color: 'red' }}>{translate.get('UM.APPROVE-RESEARCHER.REJECTED')}</span> {reason}
                    </Grid>
                )

            default:
                break
        }
    }

    return (
        <Grid container className={chooseClass(id)} spacing={2}>
            <Grid item xs={12}>
                {chooseWord(id)}
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    approved: {
        padding: '1rem',
        margin: '1rem',
        borderRadius: '5px',
        backgroundColor: '#58e68754',
    },
    reject: {
        padding: '1rem',
        margin: '1rem',
        borderRadius: '5px',
        backgroundColor: '#e6585854',
    },
}))

export default StatusBar
